export default {
  methods: {
    getDefaultValueHandler({ policy_type, value }) {
      if (policy_type === 'fixed') {
        return value;
      }
      const dict = {
        current_date_time: this.getCurrentTime,
      };
      return dict[value]();
    },
    getCurrentTime() {
      return this.$dayjs()
        .format()
        .split('+')[0];
    },
  },
};
